export const getDeletedReactions = (reactions, reaction, username) => {
  if (!reactions || !reactions[reaction]) return reactions;
  const updatedReactions = { ...reactions, [reaction]: { ...reactions[reaction] } };
  updatedReactions[reaction].users = updatedReactions[reaction].users.filter((user) => user.username !== username);
  updatedReactions[reaction].count = updatedReactions[reaction]?.users?.length;
  if (updatedReactions[reaction].count === 0) return {};
  return updatedReactions;
};

export const getUpdatedReactions = (comment, reaction, username, data) => {
  const updatedReactions = { ...(comment?.reactions || {}) };
  Object.entries(updatedReactions).forEach(([key, reactionData]) => {
    const filteredUsers = reactionData.users.filter((user) => user.username !== username);
    updatedReactions[key] = { ...reactionData, users: filteredUsers, count: filteredUsers.length };
    if (updatedReactions[key].count === 0) delete updatedReactions[key];
  });
  if (!updatedReactions[reaction]) {
    updatedReactions[reaction] = {
      name: data?.reaction_name,
      count: 1,
      users: [{ username, name: data?.actioner_name, reaction_updated_at: new Date().toISOString() }],
    };
  } else {
    updatedReactions[reaction] = {
      ...updatedReactions[reaction],
      users: [
        ...updatedReactions[reaction].users,
        { username, name: data?.actioner_name, reaction_updated_at: new Date().toISOString() },
      ],
      count: updatedReactions[reaction].count + 1,
    };
  }

  return updatedReactions;
};
